import React, { memo, useRef } from "react";
import { useStoreState, Position } from "react-flow-renderer";

import { Condi, ConditionalStyle, HandleStyle } from "./styles.js";

const ConditionalNode = ({
  data,
  id,
  targetPosition = Position.Left,
  sourcePosition = Position.Right,
  selected,
}) => {
  const edges = useStoreState((state) => state.edges);
  const nodes = useStoreState((state) => state.nodes);

  //? Popper Block

  const anchorRef = useRef(null);

  return (
    <>
      <Condi ref={anchorRef}>
        <ConditionalStyle
          className="flow_elements_node"
          data-id={id}
          status={data.status}
          selected={selected}
        >
          <HandleStyle
            type="target"
            id="c"
            style={{ top: "0" }}
            selected={selected}
            position={targetPosition}
            isValidConnection={(e) =>
              nodes.find((item) => item.id === e.source).type === "parallel" ||
              nodes.find((item) => item.id === e.source).type === "conditional"
                ? true
                : !edges.find(
                    (item) =>
                      item.target === e.target || item.source === e.source
                  )
            }
          />
          <HandleStyle
            type="source"
            position={sourcePosition}
            style={{ top: "100%" }}
            selected={selected}
            id="a"
          />
        </ConditionalStyle>
        <div style={{ padding: "10px" }}>{data.label.toUpperCase()}</div>
      </Condi>
    </>
  );
};

export default memo(ConditionalNode);
